import React from 'react';

const Error=(props)=>{
   return <div className="row">
        <div className="col-6 offset-3 text-center">
            {props.children}
        </div>
    </div>
}
export default Error;